import React from 'react';
import './ProcessPage.css';

import { Heading, PageTitle, ProcessStep } from '../../../components';
import { process } from '../../../constants';


const ProcessPage = () => { 

  return (
    <>

      {/* Page Title */}
      <PageTitle title={'Process'} page={'Process'} />

      {/* Process Section */}
      <section className='process'>

        {/* Section heading */}
        <Heading title={'Our Process'} subTitle={'water delivery process'} />

        <div className='box-container'>

          {/* Map over the process array to render each step */}
          {process.map((step) => { 
            return (
              <ProcessStep key={step.id} step={step} />
            );
          })}
        </div>

      </section>

    </>
  )
}

export default ProcessPage;